import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { first, shareReplay } from 'rxjs';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { JEService } from 'src/app/services/je-services.service';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'app-da-wise-pending-report',
  templateUrl: './da-wise-pending-report.component.html',
  styleUrls: ['./da-wise-pending-report.component.scss']
})
export class DaWisePendingReportComponent implements OnInit {

  loginUserId: any = null;
  selectedUserType: any = null;
  selectedUserId: any = null;
  userIdList: any = [];
  userTypeList: any = [];
  selectedUserAction: any = null;
  userActionList: any = [];
  tableData: any = [];
  showTableData: boolean = false;
  loading: boolean = false;
  finYearList: any = [];
  selectedFinYear: any = null;

  tableHeaderName: string = 'Pending Report';
  // selectedYear: any;
  public subscriptions: any = [];
  public subjectSub:any;


  constructor(
    private messageService: MessageService,
      // private vendorService: VendorDashboardService,
      // private router: Router,
      // private tokenService: TokenService,
      // private _fb: FormBuilder,
      // private _personalDetalSer: FarmersDetailsService,
      // private confirmationService: ConfirmationService,
      // private ipService: IpAddressService,
      private cryptoJsService: CryptoJsService,
      // private translateService: TranslateService,
      // private activityRecordService: ActivityRecordService,
      private loader: AppLoaderService,
      private reportsService:ReportsService,
      private service: BaseService,
      private dashboardService: DashboardService, 
      private router: Router,
  ) {}

  ngOnInit(): void {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.loginUserId = JSON.parse(payload)?.sub;

    this.getUserType();
    this.loadFinYearList();
  }

  onChangeUserType() {
    this.selectedUserAction = null;
    this.selectedUserId = null;
    this.userActionList = [];
    this.userIdList = [];
    this.tableData = [];
    this.showTableData = false;
    // this.selectedFinYear = null;

    // console.log(this.selectedUserType, "this.selectedUserType");
    // this.userIdList = event.value;
    // this.getUserId(this.selectedUserType?.Level_Id);
    this.getUserActionsList(this.selectedUserType?.Level_Id);
  }

  onChangeUserIdList() {
    if(this.selectedFinYear){
      this.loadFinalData();
    }

    // this.tableData = [];
    // this.showTableData = false;

    // // this.userIdList = event.value;
    // // this.getUserActionsList(this.selectedUserType, this.selectedUserId?.UserID);
    // this.getUserId(this.selectedUserType?.Level_Id);
    // // actionId, userId, userType
  }

  onChangeUserAction() {
    // if(this.selectedFinYear){
    //   this.loadFinalData();
    // }

    this.selectedUserId = null;
    this.userIdList = [];
    this.tableData = [];
    this.showTableData = false;

    // this.userIdList = event.value;
    // this.getUserActionsList(this.selectedUserType, this.selectedUserId?.UserID);
    this.getUserId(this.selectedUserType?.Level_Id ,this.selectedUserAction?.ActionId);
    // actionId, userId, userType
  }

  loadFinalData(){
    this.tableData = [];
    this.showTableData = true;

    // this.userIdList = event.value;
    // this.getUserActionsList(this.userType, this.selectedUserId);
    let actionType = this.selectedUserAction ? this.selectedUserAction.Action : '';
    this.tableHeaderName = `${this.selectedUserAction?.Action_Type} Pending Report`;

    let apiName = this.selectedUserAction?.APIName;
    this.loadPVData(apiName);

    // if(actionType == 'AppApproval') {
      
    // } else if(actionType == 'EstApproval') {
    //   this.loadPVData();
    // } else if(actionType == 'Caclulation') {

    // }else {
    //   this.showTableData = false;
    //   this.messageService.add({
    //     severity: 'warn',
    //     summary: 'Warn Message',
    //     detail:  `Someting went wrong. No data found for the selected action!`,
    //   });
    // }
  }

  onChangeFinYear(){
    if(this.selectedUserAction){
      this.loadFinalData();
    }
  }

  loadPVData(apiName: string){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    
    // let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    // let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);

    // this.loader.start();
    // apiName, userId, appType, financialyear, AppCount

    this.loading = true;
    let sub = this.dashboardService.pendingReportService(apiName, this.selectedUserId?.UserId, 'Pending', this.selectedFinYear == "All" ? '' : this.selectedFinYear, 50000)
    .pipe(first())
    .subscribe({
      next: (data) => {
        if(data.AppEstimate){
          data = data.AppEstimate;
        }
        // this.loader.close();
        this.loading = false;
        this.tableData = data;
        },
      error: (err) => {
          // this.loader.close();
          this.tableData = [];
          this.loading = false;
          if(err == 'Data not Found!'){
            this.messageService.add({ severity: 'info', summary: 'info Message', detail: 'No Data Found' });
            return;
          }
          this.showTableData = false;

          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
        }
      });

      this.subscriptions.push(sub);
  }

  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe();
    }
  }

  // loadFinYear(){
  //   if(sessionStorage.getItem('financialYear')){
  //     this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
  //   }

  //   this.subjectSub = this.service.getSelectedYear().pipe(shareReplay()).subscribe(
  //     (res) => {
  //       this.selectedYear = res;
  //       this.clearDataOnYearChange();      }
  //   );
  // }

  clearDataOnYearChange(){
    // this.selectedUserId = null;
    this.userActionList = [];
    this.selectedUserAction = null;
    this.tableData = [];
    this.showTableData = false;
  }

  getUserActionsList(userType: any) {
    this.loader.start();
    this.reportsService
      .getUserActions(userType)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.userActionList = res;
        },
        error: (error) => {
          this.userActionList = [];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail:  `Data error! ${error}`,
          });
        },
      });
  }

  getUserType() {
    this.loader.start();
    this.reportsService
      .getUserType(this.loginUserId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.userTypeList = res;
          this.loader.close();
        },
        error: (error) => {
          this.userTypeList = [];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail:  `Data error! ${error}`,
          });
        },
      });
  }

  getUserId(actionId, UserRole) {
    this.loader.start();
    this.reportsService
      .getUserList(actionId, UserRole)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.userIdList = res;
          this.loader.close();
        },
        error: (error) => {
          this.userIdList = [];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail:  `Data error! ${error}`,
          });
        },
      });
  }

  loadFinYearList(){
    this.reportsService
      .getFinanacialYearList()
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.finYearList = data; 
          const allFinYear = { FinancialYears: "All" };
          this.finYearList.push(allFinYear);
        },
        error: (error) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail:  `Data error! ${error}`,
          });
        }
      });
  }

  printForm(appId, statusCode) {
    
    if (appId) {
      let statusCodeEncrypted = this.cryptoJsService.Encrypt(statusCode);

      const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
      const loginDetails = new Map(encDataD);
      const isJEEWLogin = loginDetails.get('isJEEW') ? loginDetails.get('isJEEW') : null;
      const isDDEWLogin = loginDetails.get('isDDEW') ? loginDetails.get('isDDEW') : null;

      if(isJEEWLogin === '1'){
        this.router.navigate(['ew-je', 'appliaction-approval', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()), statusCode: statusCodeEncrypted } });

        // this.router.navigate(['ew-je', 'appliaction-approval', 'print', this.cryptoJsService.Encrypt(appId)], { queryParams: { statusCode: statusCodeEncrypted } });

      }else if(isDDEWLogin === '1'){
        this.router.navigate(['ew-department', 'appliaction-approval', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()), statusCode: statusCodeEncrypted } });

        // this.router.navigate(['ew-department', 'appliaction-approval', 'print', this.cryptoJsService.Encrypt(appId)], { queryParams: { statusCode: statusCodeEncrypted } });
      }
      // else{
      //   this.router.navigate(['department', 'appliaction-approval', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()), statusCode: statusCodeEncrypted } });

      //   // this.router.navigate(['department', 'appliaction-approval', 'print', this.cryptoJsService.Encrypt(appId)], { queryParams: { statusCode: statusCodeEncrypted } });
      // }

      let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
      let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
      const userId = (JSON.parse(payload)?.sub).toUpperCase();

      console.log('userId', userId);

      if(userId == 'ADMIN'){
        // this.router.navigate(['admin', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } });
        // this.router.navigate(['admin', 'print', this.cryptoJsService.Encrypt(appId)]);
        const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } }));
        window.open(link, '_blank');
      }else if(userId == 'CAO'){
        // this.router.navigate(['cao', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } });
        // this.router.navigate(['cao', 'print', this.cryptoJsService.Encrypt(appId)]);
        const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } }));
        window.open(link, '_blank');
      }else if(userId == 'DD-EW'){
        // this.router.navigate(['ew-department', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } });
        // this.router.navigate(['ew-department', 'print', this.cryptoJsService.Encrypt(appId)]);
        const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } }));
        window.open(link, '_blank');
      }else if(userId== 'Vendor'){
        // this.router.navigate(['vendor', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } });
        // this.router.navigate(['vendor', 'print', this.cryptoJsService.Encrypt(appId)]);
        const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } }));
        window.open(link, '_blank');
      }else if(userId== 'webadmin'){
        // this.router.navigate(['webadmin', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } });
        // this.router.navigate(['vendor', 'print', this.cryptoJsService.Encrypt(appId)]);
        const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } }));
        window.open(link, '_blank');
      }else {
        // this.router.navigate(['department', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } });
        // this.router.navigate(['department', 'print', this.cryptoJsService.Encrypt(appId)]);
        const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } }));
        window.open(link, '_blank');
      }
    }
    else{
      this.messageService.add({
        summary: 'Error Message',
        severity: 'info',
        detail: 'Application Id Not Found',
      });
    }
  }

}
